import React from 'react';

import { useAtomValue } from 'jotai';
import { dcbAtom } from '@shared/store/slice-atoms';
import { isAE } from '@entities/country';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'react-bootstrap';
import cn from 'classnames';
import { isAg26MarketingVariation } from '@shared/ui/unlock-vuz-banner';

interface IAfterClickingSubscribe {
  message?: string;
}

export const AfterClickingSubscribe: React.FC<IAfterClickingSubscribe> = ({
  message = 'after_clicking_subscribe',
}) => {
  const { homeData } = useAtomValue(dcbAtom);
  const { t } = useTranslation();
  const isAg26 = isAg26MarketingVariation();

  return homeData.operators?.length && isAE(homeData.country) ? (
    <Row>
      <Col>
        <div className={cn(isAg26 ? 'lg_ag26-after-click' : 'text-center fs-10')}>
          {t(`${message}`)}
        </div>
      </Col>
    </Row>
  ) : null;
};
